const DEFAULT_THEME = {
  wrapperBgClass: "bg-gray-50",
  wrapperBorderClass: "border-gray-200",
  wrapperBgColor: "#fbfcff",
  buttonHoverClass: "hover:bg-gray-100",
  dividerClass: "bg-gray-200",
  textColor: "#56647b",
};

export function Pagination({ page, total, perPage, onChange, isLoading, theme = {} }) {
  const mergedTheme = { ...DEFAULT_THEME, ...theme };
  const totalPages = Math.max(1, Math.ceil(total / perPage));

  return (
    <div className="w-full max-w-full overflow-x-hidden flex justify-center mt-2 md:mt-6">
      <div
        className={`max-w-full flex items-center rounded-full border shadow-sm overflow-hidden ${mergedTheme.wrapperBorderClass} ${mergedTheme.wrapperBgClass}`}
        style={{ backgroundColor: mergedTheme.wrapperBgColor }}
      >
        {/* LEFT */}
        <button
          onClick={() => onChange(page - 1)}
          disabled={page === 1 || isLoading}
          className={`px-3 md:px-6 py-2 md:py-3 ${mergedTheme.buttonHoverClass} disabled:opacity-40 transition cursor-pointer`}
          style={{ color: mergedTheme.textColor }}
        >
          ‹
        </button>

        {/* divider */}
        <div className={`w-px h-7 md:h-8 ${mergedTheme.dividerClass}`} />

        {/* CENTER */}
        <div className="px-4 md:px-8 py-2 md:py-3 text-sm md:text-base font-medium whitespace-nowrap" style={{ color: mergedTheme.textColor }}>
          Page {page}
        </div>

        {/* divider */}
        <div className={`w-px h-7 md:h-8 ${mergedTheme.dividerClass}`} />

        {/* RIGHT */}
        <button
          onClick={() => onChange(page + 1)}
          disabled={page >= totalPages || isLoading}
          className={`px-3 md:px-6 py-2 md:py-3 ${mergedTheme.buttonHoverClass} disabled:opacity-40 transition cursor-pointer`}
          style={{ color: mergedTheme.textColor }}
        >
          ›
        </button>
      </div>
    </div>
  );
}
